import React from 'react'
import NavBarEmployer from '../components/NavBarEmployer'
import Form from '../components/EditEmployerProfile/Form'
import Footer from '../components/Footer'

function EditEmployerProfile() {
  return (
    <div>
        <NavBarEmployer />
        <Form />
        <Footer />
    </div>
  )
}

export default EditEmployerProfile